// https://docs.nosto.com/shopify/guides/adding-removing-or-moving-recommendations#list-of-default-recommendation-placeholders

const validNostoPlacementIds = [
  'favorites-nosto-1',
  'frontpage-nosto-1',
  'frontpage-nosto-2',
  'frontpage-nosto-3',
  'frontpage-nosto-4',
  'frontpage-nosto-5',
  'frontpage-nosto-6',
  'frontpage-nosto-7',
  'frontpage-nosto-8',
  'frontpage-nosto-9',
  'frontpage-nosto-10',
  'frontpage-nosto-11',
  'frontpage-nosto-12',
  'productcategory-nosto-1',
  'productpage-cts-nosto-1',
  'productpage-nosto-1',
  'productpage-nosto-2',
  'productpage-nosto-3',
  'productpage-nosto-4',
  'productpage-nosto-8',
  'productpage-nosto-9',
  'productpage-nosto-10',
  'productpage-wiw-nosto-1',
  'categorypage-nosto-1',
  'categorypage-nosto-2',
  'searchpage-nosto-1',
  'searchpage-nosto-2',
  'notfound-nosto-1',
  'notfound-nosto-2',
  'notfound-nosto-3',
  'cartpage-nosto-1',
  'cartpage-nosto-2',
  'cartpage-nosto-3',
  'cartpage-nosto-4',
  'trackorderpage-nosto-1',
  'my-account-nosto-1',
] as const

export const isValidNostoPlacementId = (
  potentialNostoPlacementId: string | null | undefined
): potentialNostoPlacementId is NostoPlacementId => {
  return validNostoPlacementIds.includes(potentialNostoPlacementId as NostoPlacementId)
}

export type NostoPlacementId = (typeof validNostoPlacementIds)[number]

export interface NostoRecommendedProduct {
  handle?: string
  custom_fields?: {
    productType?: string
  }
  skus?: Array<{
    available: boolean
    custom_fields: {
      skuCode?: string
    }
  }>
}

export interface NostoRecommendation {
  div_id: NostoPlacementId
  products: readonly NostoRecommendedProduct[]
  result_id: NostoPlacementId
  title: string
}

export interface NostoLoadData {
  recommendations: Record<string, NostoRecommendation>
}

export interface NostoCartItem {
  name: string
  price_currency_code: string
  product_id: string
  quantity: number
  sku_id: string
  unit_price: number
}

export interface NostoCustomer {
  customer_reference: string
  email: string
  first_name: string
  last_name: string
  newsletter: boolean
}

export interface NostoSession {
  load(): Promise<NostoLoadData>
  setCart(cart: { items: readonly NostoCartItem[] } | {}): NostoSession
  setCustomer(customer: NostoCustomer | {}): NostoSession
  setPlacements(placements: readonly NostoPlacementId[]): NostoSession
  viewCart(): NostoSession
  viewCategory(name: string): NostoSession
  viewFrontPage(): NostoSession
  viewNotFound(): NostoSession
  viewOther(): NostoSession
  viewProduct(id: string): NostoSession
  viewSearch(term: string): NostoSession
}

export interface NostoRecommendationsRequest {
  addElements(ids: readonly NostoPlacementId[]): NostoRecommendationsRequest
  load(): Promise<NostoLoadData>
  setResponseMode(responseMode: 'JSON_ORIGINAL'): NostoRecommendationsRequest
}

export interface NostoAttribution {
  done(): void
}

export interface NostoApi {
  createRecommendationRequest(): NostoRecommendationsRequest
  defaultSession(): NostoSession
  recordAttribution(event: { type: string; target: string; ref: string }): NostoAttribution
  setAutoLoad(autoload: boolean): void
}
